import { tv } from '../tv';

export const otpInputVariants = tv({
  slots: {
    // narrower boxes on phones, so six fit a 360px screen inside a card
    root: 'relative flex items-center gap-1.5 sm:gap-2',
    group: 'flex gap-1.5 sm:gap-2',
    // transparent text and caret: the boxes show the digits
    field: `absolute inset-0 h-full w-full cursor-text bg-transparent
      text-transparent caret-transparent outline-none selection:bg-transparent`,
    box: `flex h-12 w-9 items-center justify-center rounded-btn bg-zinc-900
      text-lg font-medium sm:h-14 sm:w-12 sm:text-xl text-zinc-50 inset-ring inset-ring-zinc-50/8
      transition-shadow duration-150 motion-reduce:transition-none`,
    digit: `animate-fade animate-duration-200 animate-ease-out
      motion-reduce:animate-none`,
  },
  variants: {
    // the box the next digit goes into, while the input has focus
    active: {
      true: { box: 'inset-ring-2 inset-ring-accent-400' },
      false: {},
    },
    invalid: {
      true: { box: 'inset-ring-danger-500' },
      false: {},
    },
    disabled: {
      true: { root: 'opacity-50', field: 'cursor-not-allowed' },
      false: {},
    },
    // each box's own animation-delay turns this into a wave
    verifying: {
      true: {
        box: 'animate-digit-wave motion-reduce:animate-none',
        field: 'cursor-progress',
      },
      false: {},
    },
  },
  defaultVariants: {
    active: false,
    invalid: false,
    disabled: false,
    verifying: false,
  },
});
